import React, { Component } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import Muter from "./Muter";
import Navigasi from "./Navigasi";

const SearchLabel = styled.div`
  position: relative;
`;

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.size || "1em"
}))`
  width: 100%;
  font-size: 16px;
  font-style: italic;
  color: #4444;
  box-sizing: border-box;
  outline: none;
  padding: ${props => props.size};
`;

const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: -10px;
  font-size: 24px;
  color: #555;
  margin: 1em;
  right: 5px;
`;

class Pencarian extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      results: {},
      loading: false,
      message: "",
      totalResults: 0,
      totalPages: 0,
      currentPageNo: 0
    };
    this.cancel = "";
  }

  getPageCount = (total, perHalaman) => {
    const divisible = 0 === total % perHalaman;
    const valueToBeAdded = divisible ? 0 : 1;
    return Math.floor(total / perHalaman) + valueToBeAdded;
  };

  fetchResult = (updatePage = "", query) => {
    const pageNumber = updatePage ? `&p=${updatePage}` : "";
    const url =
      process.env.NODE_ENV == "development"
        ? `http://localhost/api/prima/AllHibah/?q=${query}${pageNumber}`
        : `https://rsuppersahabatan.co.id/apis/prima/AllHibah/?q=${query}${pageNumber}`;

    let token = process.env.REACT_APP_API;

    if (this.cancel) {
      this.cancel.cancel();
    }
    this.cancel = axios.CancelToken.source();

    const headers = { Authorization: `Persahabatan ${token}` };

    axios
      .get(url, {
        headers,
        cancelToken: this.cancel.token
      })
      .then(res => {
        const total = res.data.jumlah;
        const perHalaman = res.data.per_halaman;
        const totalPagesCount = this.getPageCount(total, perHalaman);
        const pencarianGagal = !res.data.hibah.length
          ? "Data tidak tersedia"
          : null;
        // set ke state
        this.setState({
          results: res.data.hibah,
          message: pencarianGagal,
          loading: false,
          totalResults: total,
          totalPages: totalPagesCount,
          currentPageNo: updatePage
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          message: "Gagal ambil data"
        });
      });
  };

  handleInputChange = e => {
    const query = e.target.value;
    if (!query) {
      this.setState({
        query,
        results: {},
        message: ""
      });
    } else {
      this.setState({ query, loading: true, message: "" }, () => {
        this.fetchResult(1, query);
      });
    }
  };

  handlePageClick = type => {
    event.preventDefault();
    // menentukan halaman ke berapa
    const updatePageNo =
      "prev" === type
        ? this.state.currentPageNo - 1
        : this.state.currentPageNo + 1;

    // cek muter muternya
    if (!this.state.loading) {
      this.setState(
        {
          loading: true,
          message: ""
        },
        () => {
          this.fetchResult(updatePageNo, this.state.query);
        }
      );
    }
  };

  renderResult = () => {
    const { results } = this.state;
    if (Object.keys(results) && results.length) {
      return (
        <Tbody>
          {results.map(result => {
            return (
              <Tr key={result.no_hibah}>
                <Td>{result.no_hibah}</Td>
                <Td>{result.tgl_terima}</Td>
                <Td>{result.penyumbang}</Td>
                <Td>{result.deskripsi}</Td>
              </Tr>
            );
          })}
        </Tbody>
      );
    }
  };

  render() {
    const { query, loading, message, currentPageNo, totalPages } = this.state;

    const showPrevLink = 1 < currentPageNo;
    const showNextLink = totalPages > currentPageNo;

    return (
      <div>
        <SearchLabel htmlFor="search-input">
          <Input
            value={query}
            placeholder="Pencarian donatur..."
            onChange={this.handleInputChange}
          />
          <SearchIcon icon={faSearch} />
        </SearchLabel>
        <Navigasi
          loading={loading}
          showPrevLink={showPrevLink}
          showNextLink={showNextLink}
          handlePrevClick={() => this.handlePageClick("prev", event)}
          handleNextClick={() => this.handlePageClick("next", event)}
        />
        <Table>
          <Thead>
            <Tr>
              <Th>No. Hibah</Th>
              <Th>Tgl Terima</Th>
              <Th>Nama Donatur</Th>
              <Th>Item</Th>
            </Tr>
          </Thead>
          {message ? (
            <Tbody>
              <Tr>
                <Td colSpan="4">{message}</Td>
              </Tr>
            </Tbody>
          ) : null}
          {loading ? (
            <Tbody>
              <Tr>
                <Td colSpan="4">
                  <Muter />
                </Td>
              </Tr>
            </Tbody>
          ) : null}

          {this.renderResult()}
        </Table>

        <Navigasi
          loading={loading ? true : false}
          showPrevLink={showPrevLink}
          showNextLink={showNextLink}
          handlePrevClick={() => this.handlePageClick("prev", event)}
          handleNextClick={() => this.handlePageClick("next", event)}
        />
      </div>
    );
  }
}

export default Pencarian;
